import {
  ContextualMenu,
  Modal,
  PrimaryButton,
  Stack,
  Text,
  useTheme,
} from '@fluentui/react';
import { TestGroupsSelector } from '../TestGroupsModal/TestGroupSelector';
import { CloseButton } from 'common/components/Buttons';
import { useStyles } from './index.styles';
import { useState } from 'react';
import { ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes } from '../TestGroupsModal/__generated__/ApprovalTestGroups';
import { TestGroupItemsList } from './TestGroupItemsList';
import { TestItemFormView } from './TestItemFormView';
import APPROVAL_TEST_RESULT_ATTACH from './ApprovalTestResultAttach.graphql';
import {
  ApprovalTestResultAttach,
  ApprovalTestResultAttachVariables,
} from './__generated__/ApprovalTestResultAttach';
import { useMutation } from '@apollo/client';
import { cutToast } from 'utility/toast';
import TEST_GROUPS from '../TestGroupsModal/ApprovalTestGroups.graphql';
import GET_APPROVAL_DETAILS from '../../../../../FlowApproval.graphql';
import APPROVAL_TEST_RESULTS from '../../ApprovalTestResults.graphql';

export const AttachTestGroup: React.FC<{
  onClose: () => void;
  approvalId: string;
}> = (props) => {
  const styles = useStyles();
  const theme = useTheme();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [testItem, setTestItem] = useState<
    | ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes
    | undefined
  >(undefined);

  const [groupItems, setGroupItems] = useState<
    ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes[] | []
  >([]);
  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>(
    undefined
  );
  const [attachTestResult] = useMutation<
    ApprovalTestResultAttach,
    ApprovalTestResultAttachVariables
  >(APPROVAL_TEST_RESULT_ATTACH, { errorPolicy: 'all' });

  const handleToggle = (id: string, checked: boolean) => {
    setSelectedIds((prev) =>
      checked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };

  const handleSave = async () => {
    const { errors } = await attachTestResult({
      variables: {
        input: {
          approvalId: props.approvalId,
          approvalTestItem: selectedIds,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TEST_GROUPS,
          variables: {
            filter: {
              approvalId: { equalTo: props.approvalId },
            },
            orderBy: '_FULL_COMMENT_ASC',
          },
        },
        {
          query: GET_APPROVAL_DETAILS,
          variables: {
            id: props.approvalId!,
          },
        },
        {
          query: APPROVAL_TEST_RESULTS,
          variables: {
            filter: {
              approvalId: { equalTo: props.approvalId! },
            },
            orderBy: '_FULL_COMMENT_ASC',
          },
        },
      ],
    });
    if (errors?.length) cutToast.error(errors[0].message);
    else {
      cutToast.success('Test items attached successfully.');
      props.onClose();
    }
  };
  return (
    <Modal
      isOpen
      containerClassName={
        !!testItem ? styles.modalContainerW1200 : styles.modalContainerW600
      }
      scrollableContentClassName={styles.noScrollContainer}
      dragOptions={{
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
        dragHandleSelector: '.ms-Modal-scrollableContent > div:first-child',
      }}
    >
      <Stack
        tokens={{ padding: 20, childrenGap: 30 }}
        style={{ backgroundColor: theme.palette.neutralLight }}
      >
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: 30 }}
          className={styles.headerStyle}
        >
          <Text variant="xLarge">Test Groups</Text>
          <Stack style={{ marginLeft: 'auto' }}>
            <CloseButton onClick={() => props.onClose()} />
          </Stack>
        </Stack>
        <Stack className={styles.containerStyle}>
          <Stack
            horizontal
            tokens={{ childrenGap: 30 }}
            style={{ height: '100%' }}
          >
            <TestGroupsSelector
              onChange={(value, groupItems) => {
                setSelectedGroupId(value);
                setGroupItems(groupItems);
                setSelectedIds(groupItems.map((item) => item.id));
              }}
              attachTestGroup
            />
            <TestGroupItemsList
              items={groupItems}
              selectedIds={selectedIds}
              onToggle={handleToggle}
              formViewId={testItem?.id}
              onView={(item) => {
                setTestItem(item);
              }}
            />
            {!!testItem && (
              <TestItemFormView
                testItem={testItem}
                approvalId={props.approvalId}
                onDelete={() => {
                  setSelectedIds([]);
                  setTestItem(undefined);
                }}
              />
            )}
          </Stack>
        </Stack>
      </Stack>
      <Stack
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: 30 }}
        className={styles.buttonStyle}
      >
        <PrimaryButton text="Select Test Cases" onClick={handleSave} />
      </Stack>
    </Modal>
  );
};
